import { render, staticRenderFns } from "./JapanMAJP.vue?vue&type=template&id=2b6f0c3d"
import script from "./JapanMAJP.vue?vue&type=script&lang=js"
export * from "./JapanMAJP.vue?vue&type=script&lang=js"
import style0 from "./JapanMAJP.vue?vue&type=style&index=0&id=2b6f0c3d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports